import type { ThemeDefinition } from 'vuetify'

export const customLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#fff',
    surface: '#fff',
    primary: '#004d89',
    'primary-darken-1': '#002C4D',
    secondary: '#d4a002',
    'secondary-darken-1': '#d5a000',
    error: '#FF4900',
    info: '#018CF6',
    success: '#00B668',
    warning: '#D5A000',
  },
}
